import { Component, effect, inject, model, input } from '@angular/core';
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CrudService } from '../../core/services/crud.service';
import { SupplierForm } from '../../core/services/crud.interface';
import { removeEmptyValues } from '../../shared/helpers';
import { ModalComponent } from '../../shared/components/modal/modal.component';

@Component({
  selector: 'app-supplier-form',
  imports: [ReactiveFormsModule, ModalComponent],
  templateUrl: './supplier-form.component.html',
  styles: ``,
})
export class SupplierFormComponent {
  private crudService = inject(CrudService);

  showModal = model(false);
  existingSupplier = input();

  supplierForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', Validators.email),
    phone: new FormControl('', Validators.pattern(/^\d{10}$/)),
  });

  confirmationMessage = '';
  errorMessage = '';

  buttonText = '';

  constructor() {
    effect(() => {
      if (this.showModal()) {
        // console.log(this.existingSupplier());

        // this.initializeCombos();
        // this.clearForm();
        if (this.existingSupplier() !== null) {
          this.supplierForm.patchValue({
            name: (this.existingSupplier() as any)['name'],
            email: (this.existingSupplier() as any)['email'],
            phone: (this.existingSupplier() as any)['phone'],
          });
          this.buttonText = 'Actualizar';
        } else {
          this.clearForm();
          this.buttonText = 'Crear';
        }
      }
    });
  }

  submit() {
    const cleanSupplierForm = removeEmptyValues(this.supplierForm.value);

    this.confirmationMessage = '';
    this.errorMessage = '';

    if (this.existingSupplier() !== null) {
      // this.updateCategory(cleanCategoryForm as CategoryForm);
      this.updateSupplier(this.supplierForm.value as SupplierForm);
    } else {
      this.createSupplier(cleanSupplierForm as SupplierForm);
    }
  }

  createSupplier(cleanSupplierForm: SupplierForm) {
    this.crudService.createSupplier(cleanSupplierForm).subscribe({
      next: (response: any) => {
        if (response.status === 201) {
          this.confirmationMessage = 'Proveedor añadido';
          this.clearForm();
        }
      },
      error: (error: any) => {
        if (error.status === 409) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage = 'Error inesperado. Intente nuevamente.';
        }
        this.clearForm();
      },
    });
  }

  updateSupplier(supplierForm: SupplierForm) {
    this.crudService
      .updateSupplier((this.existingSupplier() as any)['id'], supplierForm)
      .subscribe({
        next: (response: any) => {
          if (response.ok) {
            this.close();
          }
        },
      });
  }

  cancel() {
    this.close();
  }

  close() {
    this.showModal.set(false);
  }

  clearForm() {
    this.supplierForm.reset({
      name: '',
      email: '',
      phone: '',
    });
  }
}
